import IconArrowNext from "./IconArrowNext";
export default IconArrowNext;
